import type { StartupSignupFields } from '@/services/signup/api';
import type { SignupFormValues } from '../types';
import { normalizePhoneNumber } from './phone-country-codes';

export type StartupFieldValues = Pick<
  SignupFormValues,
  | 'startupFunding'
  | 'startupSize'
  | 'incubatorVc'
  | 'businessDescription'
  | 'phoneCountry'
  | 'phone'
  | 'companyLocation'
  | 'heardAboutUs'
>;

/**
 * The startup-program fields in the shape the API expects. One mapper for both
 * consumers — the pre-creation application POST and the register call's
 * `meta.startup` — so the Marketing event and the persisted `account_meta`
 * blob can't drift.
 */
export function mapStartupFields(values: StartupFieldValues): StartupSignupFields {
  return {
    funding_level: values.startupFunding,
    company_size: values.startupSize,
    incubator_partner: values.incubatorVc,
    business_description: values.businessDescription,
    phone: normalizePhoneNumber(values.phoneCountry, values.phone),
    company_location: values.companyLocation,
    heard_about_us: values.heardAboutUs,
  };
}
